import { render, staticRenderFns } from "./ElementShow.vue?vue&type=template&id=136c371d"
import script from "./ElementShow.vue?vue&type=script&lang=ts"
export * from "./ElementShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports